import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Sparkles, Play, Trash2, Timer } from "lucide-react";

export default function Workouts() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/workouts").then((r) => setItems(r.data)).finally(() => setLoading(false));
  };

  useEffect(load, []);

  const del = async (id) => {
    if (!window.confirm("Eliminare questa scheda?")) return;
    try {
      await api.delete(`/workouts/${id}`);
      toast.success("Scheda eliminata");
      load();
    } catch {
      toast.error("Errore eliminazione");
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="flex items-end justify-between mb-8 flex-wrap gap-4">
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#A0A0AB] mb-2">Il tuo arsenale</div>
          <h1 className="font-display text-5xl sm:text-6xl font-black uppercase tracking-tighter leading-[0.9]">
            Schede <span className="text-[#FF3B30]">salvate</span>
          </h1>
        </div>
        <Link
          to="/coach"
          data-testid="new-workout-btn"
          className="bg-[#FF3B30] text-white font-bold uppercase tracking-widest px-5 py-3 hover:bg-[#e02e24] transition-all flex items-center gap-2"
        >
          <Sparkles className="w-4 h-4" /> Nuova con IA
        </Link>
      </div>

      {loading ? (
        <div className="text-[#A0A0AB] font-display uppercase tracking-widest text-sm">Caricamento...</div>
      ) : items.length === 0 ? (
        <div className="border border-[#2A2A35] p-12 text-center">
          <div className="font-display text-3xl font-bold uppercase mb-2">Nessuna scheda</div>
          <div className="text-[#A0A0AB] mb-6">Genera la prima con il Coach IA — bastano 10 secondi.</div>
          <Link to="/coach" className="inline-flex items-center gap-2 bg-[#FF3B30] text-white font-bold uppercase tracking-widest px-6 py-3">
            <Sparkles className="w-4 h-4" /> Vai al Coach
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 stagger">
          {items.map((w) => (
            <div
              key={w.id}
              data-testid={`wo-${w.id}`}
              className="border border-[#2A2A35] p-5 hover:border-[#FF3B30] transition-all group"
            >
              <div className="flex items-center gap-2 mb-2">
                {w.ai_generated && (
                  <span className="text-[9px] uppercase tracking-widest text-[#E2FF31] flex items-center gap-1">
                    <Sparkles className="w-3 h-3" />IA
                  </span>
                )}
                <span className="text-[10px] uppercase tracking-widest text-[#A0A0AB]">{w.focus}</span>
              </div>
              <Link to={`/workouts/${w.id}`} className="block">
                <div className="font-display text-2xl font-bold uppercase leading-tight mb-3 group-hover:text-[#FF3B30] transition-colors">
                  {w.title}
                </div>
                <div className="text-xs text-[#A0A0AB] flex items-center gap-3 mb-4">
                  <span className="flex items-center gap-1"><Timer className="w-3 h-3" />{w.duration_min} min</span>
                  <span>·</span>
                  <span>{w.exercises.length} esercizi</span>
                </div>
              </Link>
              <div className="flex gap-2 pt-3 border-t border-[#2A2A35]">
                <Link
                  to={`/session/${w.id}`}
                  data-testid={`start-${w.id}`}
                  className="flex-1 bg-[#FF3B30] text-white font-bold uppercase tracking-widest text-xs py-2 flex items-center justify-center gap-1 hover:bg-[#e02e24]"
                >
                  <Play className="w-3 h-3 fill-white" /> Inizia
                </Link>
                <button
                  onClick={() => del(w.id)}
                  data-testid={`del-${w.id}`}
                  className="border border-[#2A2A35] hover:border-[#EF4444] hover:text-[#EF4444] px-3 py-2 transition-all"
                  aria-label="Elimina"
                >
                  <Trash2 className="w-3 h-3" />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
